import styled from 'styled-components';
import { darken } from 'polished';

export const Wrapper = styled.div`
  background: #ffffff;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const Content = styled.div`
  width: 1068px;
  margin: 0 auto;

  form {
    display: flex;
    flex-direction: column;

    input {
      background: #ffffff;
      border: 0;
      border-radius: 4px;
      height: 37px;
      padding: 0 15px;
      color: #282828;
      margin: 0 0 0 0;
      box-shadow: inset 0px 1px 0px 0px #c7c7c794;

      border: solid 1px #c7c7c794;

      &::placeholder {
        color: #282828;
      }
    }

    span {
      color: #cc0000;
      align-self: flex-start;
      margin-top: 0;
      font-size: 9px;
    }

    span.notice {
      font-size: 8.5px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.18;
      letter-spacing: 0px;
      text-align: right;
      color: #282828;
      align-self: flex-end;
      margin-bottom: 5px;
    }
    span.noticeInfo {
      font-size: 11px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.09;
      letter-spacing: 0.01px;
      text-align: left;
      color: #282828;
      display: block;
      margin-top: 4px;
    }

    button {
      background: #74a50a;
      max-width: 74px;
      height: 34px;
      border-radius: 3.5px;

      color: #fff;
      border: 0;

      font-size: 13px;
      transition: background 0.2s;

      &:hover {
        background: ${darken(0.03, '#74a50a')};
      }
    }

    a {
      color: #282828;
      margin-top: 15px;
      font-size: 16px;
      opacity: 0.8;

      &:hover {
        opacity: 1;
      }
    }
  }
`;
